var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10294 3.15V0.75M18.3971 3.15V0.75M12.75 24.75C7.09306 24.75 4.26529 24.75 2.50765 23.1684C0.75 21.5868 0.75 19.0404 0.75 13.95C0.75 8.8596 0.75 6.3132 2.50765 4.7316C4.26529 3.15 7.09306 3.15 12.75 3.15C18.4069 3.15 21.2347 3.15 22.9924 4.7316C24.75 6.3132 24.75 8.8596 24.75 13.95C24.75 19.0404 24.75 21.5868 22.9924 23.1684C21.2347 24.75 18.4069 24.75 12.75 24.75Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5973 9.74375C15.5973 10.3803 15.2998 10.9907 14.7703 11.4408C14.2408 11.8909 13.5226 12.1437 12.7738 12.1437C12.0249 12.1437 11.3068 11.8909 10.7773 11.4408C10.2477 10.9907 9.95026 10.3803 9.95026 9.74375C9.95026 9.10723 10.2477 8.49678 10.7773 8.04669C11.3068 7.59661 12.0249 7.34375 12.7738 7.34375C13.5226 7.34375 14.2408 7.59661 14.7703 8.04669C15.2998 8.49678 15.5973 9.10723 15.5973 9.74375ZM7.19026 18.4113C8.68391 16.4553 11.0571 15.7233 12.7738 15.7245C14.4905 15.7257 16.7945 16.4565 18.2881 18.4125C18.3841 18.5385 18.411 18.6934 18.3234 18.8254C17.9747 19.3522 16.8891 20.3973 16.107 20.4681C15.2063 20.5485 12.85 20.5605 12.7752 20.5605C12.7004 20.5605 10.2736 20.5485 9.37285 20.4681C8.58791 20.3961 7.50367 19.3521 7.15355 18.8241C7.06744 18.6933 7.09426 18.5385 7.19026 18.4113Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.4a7f716ce673ea6bec19b96d8bd81a5a.svg";
export { ForwardRef as ReactComponent };